import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/icon/iconfont.css'
import '@/assets/css/reset.css'
import '@/assets/css/commons.less'

Vue.use(ElementUI)

import router from '@/router.js'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import VueResource from 'vue-resource'
Vue.use(VueResource)

import store from '@/store/index.js'
import '@/server/filter.js'
import permission from '@/server/permission.js'
Vue.use(permission)

import CodeDiff from 'v-code-diff'
Vue.use(CodeDiff);

Vue.config.productionTip = false

Vue.component('tree1',resolve=>require(['./components/tree/src/tree.vue'],resolve))
Vue.component('v-select',resolve => require(['./components/vselect.vue'],resolve))
Vue.component('operate-panel', resolve => require(['./components/operatePanel.vue'], resolve))
Vue.component('table-panel', resolve => require(['./components/tablePanel.vue'], resolve))
Vue.component('pop-up', resolve => require(['./components/popup.vue'], resolve))
Vue.component('v-radio', resolve => require(['./components/vradio.vue'], resolve))
Vue.component('v-checkbox', resolve => require(['./components/vcheckbox.vue'], resolve))

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale:'zh',
  messages: {
    'zh': require('@/assets/lang/zh'),
    'en': require('@/assets/lang/en')
  }
})

// 开发环境
// global.amsUrl = "http://localhost:10001";
// global.etpUrl = "http://localhost:10005";

// 测试环境
// global.amsUrl = "http://129.226.216.66:8080"
// global.etpUrl = "http://129.226.216.66:8080"

// 生产环境
global.amsUrl = "https://data.answeraiops.com";
global.etpUrl = "https://data.answeraiops.com";

function getCookieValueByKey(key){
  return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)'+ key +'\\s*\\=\\s*([^;]*).*$)|^.*$'), "$1")
}

global.bus = new Vue();

Vue.http.options.withCredentials = true
var showCount = 0;
Vue.http.interceptors.push(function (request,next) {
  const noJudgeErrMsg = request?.noJudgeErrMsg || false;
  showCount++;
  bus.$emit("showLoading",showCount)
  // bus.showLoading = true;
  request.headers.map['Authorization'] = [getCookieValueByKey("token")];
  request.headers.map['X-Requested-With'] = ["XMLHttpRequest"];
  var path = /^\/(\w|\-)+(?=\/|$)/.exec(request.url)
  path = path && path[0]
  switch (path) {
    case '/ams':
      request.url = amsUrl + request.url;
      break;
    case '/etp':
      request.url = etpUrl + request.url;
      break
    default:
      request.url = amsUrl + request.url;
      break;
  }
  next(function (res) {
    let isAlert = false;
    showCount--;
    bus.$emit("showLoading",showCount)
    if (res.status != 200) {
      switch (res.status) {
        case 403:
          if (!isAlert) {
            isAlert = true
            if(res.data.err_code == 20004) {
              // window.alert("没有权限！");
              this.$notify({
              title: 'Error',
              message: '权限不足',
              type: 'error'
              })
            } else {
              // window.alert('请登录!!');
              document.cookie="token=;Max-Age=-99999999;";
              this.__next('/login?ret='+this.__path);
            }
            setTimeout(function () {
              isAlert = false
            }, 30)
          }
          break;
        case 500:
              // window.alert("内部服务错误!");
          this.$notify({
            title: 'Error',
            message: '内部服务器错误！',
            type: 'error'
          })
        default:
          break;
      }
    }else if (res.data.err_msg&&!noJudgeErrMsg) {
      // window.alert(res.data.err_msg)
      this.$notify({
        title: res.data.err_code == 0 ? 'Success': 'Error',
        message: res.data.err_msg,
        type: res.data.err_code == 0 ? 'success': 'error'
      })
      if(res.data.err_msg) {
        throw res.data.err_msg || res.data.msg
      }
    }
  })
})


var vue = global.bus;

router.beforeEach(function (to,from,next) {

  vue.__next = next;
  vue.__path = to.path
  vue.__app_id=to.params.app_id;
  vue.__system=to.params.system;
  if (to.type == 'public') {
    return next();
  }
  if(to.path=='/login') {
    if (getCookieValueByKey('token')) {
      next('home');
    }
    return next();
  }
  var path = to.matched.map(v=>v.path);
  var url = "";
  for(var i=0;i<path.length;i++) {
    if(i==0) {
      url += "?url=" + path[i];
    } else {
      url += "&url=" + path[i];
    }
  }

  if (to.params.system) {
    url += `&system=${to.params.system}`
  }

  var _this = vue;
  if((to.path||from.path)&&to.path==from.path){
    return next();
  }else{
    vue.$http.get('/ams/admin/page'+url).then(async (res) => {
      if(!res.data.page) {
        return next();
      }

      if(res.data.page.is_menu) {
        var path = res.data.page.children[0].url.replace(":app_id",_this.__app_id).replace(":system", _this.__system);

        if(path.indexOf(_this.__path)>-1&&path != _this.__path) {
          return next({path: path})
        }
      }

      var rights = {};
      var pages = [];
      (res.data.page.children || []).map(v=> {
        rights[v.right] = true
        if(v.url) {
          pages.push(v);
        }
      });
      to.meta.__mixin_count = 0;
      to.meta.rights = rights;
      to.meta.page = (res.data.page||[]);
      to.meta.menu = res.data.menu;

      if (_this.__system) {

        if (_this.__system != store.state.system) {
          let rst = await vue.$http.get(`/etp/v1.0/app/list?system=${_this.__system}&sort=asc`);
          let apps = rst.data.data;
          store.commit('updateApps', apps);
          store.commit('setSystem', _this.__system);
          store.commit('setAppId', apps[0].id);
        }

      } else {

        store.commit('setSystem', "");

      }

      return next();
    });
  }

});

new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
}).$mount('#app')
